<template>
  <div v-if="product != null && prices != null">
    <div v-if="product.has_list">
      <section class="text_center">
        <h2 class="header_underline">コンビニ・ドラッグストアで購入</h2>

        <p class="text_left">
          お近くのコンビニやドラッグストアでポイントを購入することができます。既にBitCashを購入済みの方は<a href="#" class="link_main--text text-decoration-underline" @click.prevent="scrollToRefs('purchased')">こちら</a>
        </p>
        <ul class="store_list">
          <li><router-link :to="{ name: 'PointBitcashStore', params: { store: 'seven' } }">
            <img src="/assets/img/point/bitcash/seven.png" alt="セブンイレブン" /></router-link></li>
          <li><router-link :to="{ name: 'PointBitcashStore', params: { store: 'lawson' } }">
            <img src="/assets/img/point/bitcash/lawson.png" alt="ローソン" /></router-link></li>
          <li><router-link :to="{ name: 'PointBitcashStore', params: { store: 'familymart' } }">
            <img src="/assets/img/point/bitcash/familymart.png" alt="ファミリーマート" /></router-link></li>
          <li><router-link :to="{ name: 'PointBitcashStore', params: { store: 'ministop' } }">
            <img src="/assets/img/point/bitcash/ministop.png" alt="ミニストップ" /></router-link></li>
          <li><router-link :to="{ name: 'PointBitcashStore', params: { store: 'others' } }">
            <img src="/assets/img/point/bitcash/others.png" alt="その他のコンビニ" /></router-link></li>
          <li><router-link :to="{ name: 'PointBitcashStore', params: { store: 'drugstore' } }">
            <img src="/assets/img/point/bitcash/drugstore.png" alt="全国のドラッグストア等" /></router-link></li>
        </ul>
        <div class="notice text_left">
          <p>上記からお近くのお店を選択して頂くと、詳しい購入方法がご覧頂けます。</p>
        </div>
        <div class="notice text_left">
          <p>お店でBitCashをご購入いただき、そのBitCashを使用して番組内のポイントを購入する流れになります。</p>
        </div>
      </section>
      <div ref="purchased">
        <point-bitcash-form-set
          :user="user"
          :info="info"
          :product="product"
          :prices="prices"
        />
      </div>
    </div>
    <div v-else>
      <section class="suspension text_center">
        <p>準備中</p>
        <p><router-link to="/" class="arrow link_main--text">トップページへ戻る</router-link></p>
      </section>
    </div>
  </div>
</template>

<script>
import PointBitcashFormSet from '@/components/point/PointBitcashFormSet'
import { SET_SCROLL_POSITION } from '@/store/common/mutations'
import {
  GET_PRODUCT,
  GET_PRICE_LIST
} from '@/store/point/actions'

export default {
  name: 'PointBitcashForm',
  components: {
    PointBitcashFormSet
  },
  data () {
    return {
      user: this.$store.getters.loginUser || null,
      info: this.$store.getters.siteInfo || null,
      paymentWay: 'bitcash',
      product: null,
      prices: null
    }
  },
  computed: {
    loginUser () {
      return this.$store.getters.loginUser
    },
    siteInfo () {
      return this.$store.getters.siteInfo
    }
  },
  methods: {
    getProduct () {
      this.$store.dispatch(GET_PRODUCT, {
        paymentWay: this.paymentWay
      })
        .then((data) => {
          this.product = data

          if (!data.has_list) {
            this.$router.push({ name: 'PointPurchase' })
          }
        })
        .catch(() => {
          this.$router.push({ name: 'PointPurchase' })
        })
    },
    getPrices () {
      this.$store.dispatch(GET_PRICE_LIST, {
        paymentWay: this.paymentWay
      })
        .then((data) => {
          this.prices = data.prices
        })
        .catch(() => {
          this.$router.push({ name: 'PointPurchase' })
        })
    },
    scrollToRefs (refName) {
      this.$store.commit(SET_SCROLL_POSITION, this.$refs[refName].offsetTop - 8)
    }
  },
  created () {
    this.getProduct()
    this.getPrices()
  },
  watch: {
    loginUser (val, old) {
      this.user = val
    },
    siteInfo (val, old) {
      this.info = val
    }
  }
}
</script>
